import { Success } from "@/Utils/BaseUrl";
import React from "react";
import { useTranslation } from "react-i18next";

const StepFive = ({ navigate }) => {
  const {t}= useTranslation()
  return (
    <div className="w-full flex flex-col items-center justify-center">
      <img src={Success} alt="" className="w-[50%] h-[50%]" />
      <h3 className="text-[28px] font-semibold text-[#0C0A20]">
        {t("You’re all set!")}
      </h3>
      <p
        className="text-center text-[#6D6C79] font-inter text-sm font-medium leading-5 tracking-[-0.14px]
"
      >
        {t("Explore deals, discover brands, and enjoy a")} <br /> {t("shopping experience made for you.")}
      </p>
      <button
        onClick={() => navigate("/")}
        className=" flex
  h-[48px]
  px-[24px] 
  w-full mt-3
  justify-center
  items-center
  gap-[8px]
  self-stretch
  rounded-[6px] cursor-pointer 
  bg-blue-500
  text-white font-bold"
      >
        {t("Start shopping")}
      </button>
      <button
        onClick={() => navigate("/login")}
        className=" flex
  h-[48px]
  px-[24px] 
  w-full mt-3
  justify-center
  items-center
  gap-[8px]
  self-stretch
  rounded-[6px] cursor-pointer
  bg-[#F3F3F4]
  text-black font-bold"
      >
        {t("Login")}
      </button>
    </div>
  );
};

export default StepFive;
